import { Check, TrendingDown } from 'lucide-react';

const pricingPlans = [
  {
    size: '2-Zimmer-Wohnung',
    priceFrom: '3\'900',
    volume: 'ca. 20-30 m³',
    features: [
      'Kompletter Transport',
      'Premium-Verpackungsmaterial',
      'Einpackservice falls gewünscht',
      'Möbelmontage & -demontage',
      'Zollabwicklung',
      'Versicherung inklusive',
      'Kostenlose Besichtigung',
    ],
  },
  {
    size: '3-Zimmer-Wohnung',
    priceFrom: '5\'900',
    volume: 'ca. 35-45 m³',
    features: [
      'Kompletter Transport',
      'Premium-Verpackungsmaterial',
      'Einpackservice falls gewünscht',
      'Möbelmontage & -demontage',
      'Zollabwicklung',
      'Versicherung inklusive',
      'Kostenlose Besichtigung',
    ],
    popular: true,
  },
  {
    size: '4-Zimmer-Wohnung',
    priceFrom: '7\'900',
    volume: 'ca. 50-65 m³',
    features: [
      'Kompletter Transport',
      'Premium-Verpackungsmaterial',
      'Einpackservice falls gewünscht',
      'Möbelmontage & -demontage',
      'Zollabwicklung',
      'Versicherung inklusive',
      'Kostenlose Besichtigung',
    ],
  },
];

export default function Pricing() {
  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="preise" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block bg-slate-800 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Transparente Preise
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Kosten & Preise
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Faire Fixpreise ohne versteckte Kosten. Alle Preise verstehen sich als Richtwerte und werden individuell kalkuliert.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={`rounded-2xl p-8 transition ${
                plan.popular
                  ? 'bg-slate-800 text-white shadow-2xl scale-105 border-4 border-slate-700'
                  : 'bg-white border-2 border-slate-200 hover:border-slate-800'
              }`}
            >
              {plan.popular && (
                <div className="bg-white text-slate-800 text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
                  Beliebteste Wahl
                </div>
              )}
              <h3 className={`text-2xl font-bold mb-2 ${plan.popular ? 'text-white' : 'text-slate-900'}`}>
                {plan.size}
              </h3>
              <div className={`text-sm mb-6 ${plan.popular ? 'text-slate-300' : 'text-slate-600'}`}>
                {plan.volume}
              </div>
              <div className="mb-6">
                <div className={`text-sm ${plan.popular ? 'text-slate-300' : 'text-slate-600'}`}>
                  ab
                </div>
                <div className="flex items-baseline">
                  <span className={`text-5xl font-bold ${plan.popular ? 'text-white' : 'text-slate-900'}`}>
                    CHF {plan.priceFrom}
                  </span>
                  <span className={`ml-2 ${plan.popular ? 'text-slate-300' : 'text-slate-600'}`}>
                    .–
                  </span>
                </div>
              </div>
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-start space-x-3">
                    <Check className={`w-5 h-5 flex-shrink-0 mt-0.5 ${plan.popular ? 'text-green-400' : 'text-green-600'}`} />
                    <span className={`text-sm ${plan.popular ? 'text-slate-200' : 'text-slate-700'}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
              <button
                onClick={scrollToContact}
                className={`w-full py-3 rounded-lg font-semibold transition ${
                  plan.popular
                    ? 'bg-white text-slate-800 hover:bg-slate-100'
                    : 'bg-slate-800 text-white hover:bg-slate-900'
                }`}
              >
                Offerte anfordern
              </button>
            </div>
          ))}
        </div>

        <div className="relative bg-white rounded-2xl p-8 md:p-10 border-2 border-slate-200 overflow-hidden">
          <div className="absolute top-0 right-0 w-1/3 h-full opacity-5">
            <img
              src="/umzug-schweiz-deutschland.jpeg"
              alt="Umzug Schweiz Deutschland"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10">
          <div className="flex items-start space-x-4 mb-6">
            <div className="bg-green-50 rounded-full p-3">
              <TrendingDown className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-2">
                Preise abhängig von
              </h3>
              <p className="text-slate-600 leading-relaxed">
                Jeder Umzug ist individuell. Die endgültigen Kosten hängen von verschiedenen Faktoren ab:
              </p>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-slate-800 rounded-full"></div>
                <span className="text-slate-700">Distanz zwischen Start- und Zielort</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-slate-800 rounded-full"></div>
                <span className="text-slate-700">Umzugsvolumen in Kubikmetern</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-slate-800 rounded-full"></div>
                <span className="text-slate-700">Stockwerk & Lift-Verfügbarkeit</span>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-slate-800 rounded-full"></div>
                <span className="text-slate-700">Gewünschte Zusatzleistungen</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-slate-800 rounded-full"></div>
                <span className="text-slate-700">Umzugstermin & Dringlichkeit</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-slate-800 rounded-full"></div>
                <span className="text-slate-700">Besondere Gegenstände (Piano, Tresor)</span>
              </div>
            </div>
          </div>
          <div className="mt-8 bg-slate-50 rounded-lg p-6">
            <p className="text-slate-700 text-center">
              <span className="font-bold">Kostenlose Besichtigung:</span> Wir erstellen Ihnen nach einer kostenlosen Besichtigung vor Ort oder online eine transparente Fixpreis-Offerte – garantiert ohne versteckte Kosten!
            </p>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
}
